import { Component, Input, Output, EventEmitter, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-datepicker',
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DatepickerComponent),
      multi: true
    }
  ],
  template: `
    <div style="position:relative;display:inline-flex;width:100%;">
      <input [type]="inputType"
             class="form-input"
             [class]="inputStyleClass"
             [id]="inputId"
             [placeholder]="placeholder"
             [value]="dateString"
             [disabled]="isDisabled"
             (focus)="onFocus($event)"
             (blur)="onBlurEvent($event)"
             (change)="onInputChange($event)">
    </div>
  `
})
export class DatepickerComponent implements ControlValueAccessor {
  @Input() placeholder = '';
  @Input() showIcon = false;
  @Input() inputStyleClass = '';
  @Input() inputId = '';
  @Input() dateFormat = '';

  @Output() onBlur = new EventEmitter<void>();

  dateString = '';
  isDisabled = false;
  inputType = 'text';

  private onChange: (val: any) => void = () => {};
  private onTouched: () => void = () => {};

  onFocus(event: Event): void {
    this.inputType = 'date';
    const input = event.target as HTMLInputElement;
    setTimeout(() => {
      try { input.showPicker(); } catch (_) {}
    });
  }

  onBlurEvent(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.value) {
      this.inputType = 'text';
    }
    this.onTouched();
    this.onBlur.emit();
  }

  onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    const val = input.value;
    if (val) {
      const parts = val.split('-');
      const date = new Date(+parts[0], +parts[1] - 1, +parts[2]);
      this.dateString = val;
      this.onChange(date);
    } else {
      this.dateString = '';
      this.onChange(null);
    }
  }

  writeValue(val: any): void {
    if (val instanceof Date) {
      const y = val.getFullYear();
      const m = String(val.getMonth() + 1).padStart(2, '0');
      const d = String(val.getDate()).padStart(2, '0');
      this.dateString = `${y}-${m}-${d}`;
      this.inputType = 'date';
    } else if (typeof val === 'string' && val) {
      this.dateString = val;
      this.inputType = 'date';
    } else {
      this.dateString = '';
      this.inputType = 'text';
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }
}
